import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import modules from './modules'
export default new Vuex.Store({
  state: {
    mapKey: 'web.cD8znwtry0tsOHLhZmP0b6k6o2bxDViPyqpVXSnv',
    apis: {},
    loading: false,
    tourCart: {},
    tourPassengers: [],
    userData: [],
    isLogin: false,
    residenceSelected: [],
    residencePrice: 0,
    roomSelected: [],
    residenceDateSelected: [],
    residenceRatePlanSelected: "",
    residenceCapacity:0,
    residenceRules: [],
    corridorReportTrip: {
      tripTitle: 'this.tripTitle',
      origin: "this.origin",
      destination: "this.destination",
      startDate: "this.startDate",
      endDate: "this.endDate",
      countOfPassenger: "this.countOfPassenger",
      fuel: "this.fuel",
      distance: "this.distance",
      duration: "this.duration",
      placesInTrip: [],
      naghlieLists: [],
      destinationCountPlacesChart: [],
      originCountPlacesChart:[],
      chartCatReligious: [],
      budget: '',
      countOfPassenger: '',
      compChartDestination: [],
      compChartOrigin: [],
      percentOfOrigin: 0,
      percentOfDestination: 0,
      typeTripLists: [],
      tripGardeshgariType:[]
    }
  },

  getters: {

  },
  mutations: {
    LOGOUT(state) {
      state.isLogin = false
      localStorage.removeItem('accessToken')
    }
  },
  actions: {
    logOut(context) {
      context.commit('LOGOUT')
    }
  },
  modules
})
